/**
 * Parses comma-separated values into an array
 * @param {string|Array} value - The value to parse (string or array)
 * @returns {Array} - Array of trimmed non-empty values
 */
export const parseCommaSeparatedValues = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value.filter(Boolean);

    return value
        .toString()
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
};

/**
 * Encodes spaces in URL to %20
 * @param {string} url - The URL to encode
 * @returns {string} - URL with encoded spaces
 */
const encodeSpaces = (str) => str.replace(/ /g, '%20');

export const encodeAssetUrl = (url) => {
    if (url == null) return '';
    if (typeof url === 'string') return encodeSpaces(url);
    if (url.path) return encodeSpaces(url.path);
    if (url.idPath) return encodeSpaces(url.idPath);
    return '';
};
